module.exports = __webpack_public_path__ + "static/media/Spotify.1491b40b.svg";